<ov-suite-form
  #form
  [formClass]="entity"
  [data]="data"
  [showSave]="false"
  [viewMode]="true"
></ov-suite-form>
